import React, { useMemo } from "react";
import { IonButton } from "@ionic/react";
import i18n from "i18n";
import { showLoadCount } from "./utils";
export interface showLoadCountBtnProps {
  onShowMore: any;
  shouldShowLoadMoreUpdate: boolean;
  totalRecords: number;
  currentPage: number;
  pageSize: number;
}
const ShowLoadCountBtn: React.FC<showLoadCountBtnProps> = (
  props: showLoadCountBtnProps
) => {
  let {
    totalRecords,
    currentPage,
    pageSize,
    shouldShowLoadMoreUpdate,
    onShowMore
  } = props;
  const loadCount: number | null = useMemo(
    () => showLoadCount(totalRecords, currentPage, pageSize),
    [shouldShowLoadMoreUpdate, totalRecords]
  );
  return (
    <IonButton
      className="btn-common-web"
      onClick={(event: any) => {
        onShowMore(event);
      }}
    >
      {i18n.t("Show")} {loadCount} {i18n.t("More")}
    </IonButton>
  );
};
export default ShowLoadCountBtn;
